<template>
    <section>
        <p class="d-none d-md-block text--secondary font-italic pl-3">
            <span v-if="filteredProfiles.length > 1">{{ filteredProfiles.length }} profielen gevonden</span>
            <span v-else-if="filteredProfiles.length <= 0">Geen profielen gevonden</span>
            <span v-else>Eén profiel gevonden</span>
        </p>
        <ul class="list-unstyled">
            <li v-for="profile in paginatedProfiles" :key="profile.uuid" class="mb-4">
                <ProfileCard :profile="profile"></ProfileCard>
            </li>
        </ul>
        <v-pagination
            v-if="pageLength > 1"
            v-model="page"
            :length="pageLength"
            circle
            prev-icon="fal fa-angle-left"
            next-icon="fal fa-angle-right"
            :total-visible="($vuetify.breakpoint.mdAndDown) ? 5 : 10"
            class="mt-7"
        ></v-pagination>
    </section>
</template>

<script>
import {mapState} from "vuex";
import ProfileCard from "./ProfileCard";

export default {
    name: "ProfileList",
    components: {ProfileCard},
    props: {
        profilesPerPage: {
            type: Number,
            default: 5,
        },
    },
    computed: {
        paginatedProfiles () {
            const offset = (this.page - 1) * this.profilesPerPage;
            return this.filteredProfiles.slice(offset, offset + this.profilesPerPage);
        },
        page: {
            get () { return this.profilePage; },
            set (value) { this.$store.dispatch('updateProfilePage', value); }
        },
        pageLength () {
            return Math.ceil(this.filteredProfiles.length / this.profilesPerPage);
        },
        ...mapState({
            filteredProfiles: state => state.profile.filteredProfiles,
            profilePage: state => state.profile.profilePage,
        }),
    },
    methods: {
        resetPagination () {
            this.page = 1;
        },
    },
}
</script>

<style scoped>

</style>
